// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getBlogList } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const getBlogListData = createAsyncThunk(
  "getBlogListData",
  async (search = "") => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: {
          search,
        },
      };
      const url = ApiBaseUrl + getBlogList;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const BlogSlice = createSlice({
  name: "getBlogReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearBlogData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBlogListData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBlogListData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getBlogListData.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearBlogData } = BlogSlice.actions;
export default BlogSlice.reducer;
